import { Route, State as RouteState } from 'config/routes';
import { call, fork, put, select } from 'redux-saga/effects';
import { agentIdSelector, managedOfficeSelector } from 'store/state/domainData/selectors';
import { navigateTo } from 'store/state/router/actions';
import { resetDomainData } from 'store/state/domainData/actions';
import { prevRouteSelector } from 'store/state/selectors/router';
import { LoadType } from 'store/sagas/apiService/types';
import { IPublicRealEstateAgent, RealEstateLevel } from 'utils/entities';
import { queryData } from 'store/sagas/apiService';
import { publicAgentPageDataSelector } from 'store/state/domainData/selectors/agentById';


function* agentPageWorker(route: RouteState) {
  const ownAgentId: string = yield select(agentIdSelector);
  const managedOfficeId: string | null = yield select(managedOfficeSelector);

  const { agentId } = route.params;

  const isOwnAgent = route.params.agentId === ownAgentId;

  if (isOwnAgent || managedOfficeId) {
    const prevRoute: RouteState | null = yield select(prevRouteSelector);

    if (prevRoute) {
      yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateOfficeById }));
      yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateAgentById }));
      yield put(resetDomainData({ loadType: LoadType.OfficeBulletinsById }));
    }

    yield call(queryData, { loadType: LoadType.GetPublicRealEstateAgentById, meta: { variables: { agentId } } });
    const agentData: IPublicRealEstateAgent = yield select(publicAgentPageDataSelector);

    if (agentData && (isOwnAgent || agentData.officeId === managedOfficeId)) {
      const officeId = agentData.officeId;
      yield fork(queryData, { loadType: LoadType.GetPublicRealEstateOfficeById, meta: { variables: { officeId } } });
      yield fork(queryData, { loadType: LoadType.OfficeBulletinsById, meta: { variables: { id: officeId, level: RealEstateLevel.Public } } });
    }
    else {
      yield put(navigateTo(Route.AgentConsoleHomePage, { replace: true }));
    }
  }
  else {
    yield put(navigateTo(Route.AgentConsoleHomePage, { replace: true }));
  }
}

export function* officeAgentPageHandler(params: RouteState) {
  yield call(agentPageWorker, params);
}
